import { render, staticRenderFns } from "./SMSToPatient.vue?vue&type=template&id=a725feba&scoped=true&"
import script from "./SMSToPatient.vue?vue&type=script&lang=js&"
export * from "./SMSToPatient.vue?vue&type=script&lang=js&"
import style0 from "./SMSToPatient.vue?vue&type=style&index=0&id=a725feba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a725feba",
  null
  
)

export default component.exports